import type { Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';
import type { RequestMeta, ResponseMeta } from '@/shared/api/types';

export const getStacklets = (
  params?: RequestMeta,
): Promise<{ meta: ResponseMeta; stacklets: Stacklet[] }> =>
  request({
    url: '/stacklets/',
    params,
  });
